(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('scroll_probe') !== '1') return;

  const state = {
    active: false,
    startY: 0,
    startScrollY: 0,
    currentY: 0,
    lastTouchTime: 0,
    maxTouchGap: 0,
    maxScrollGap: 0,
    lastScrollTime: 0,
    longTasks: 0,
    maxLongTask: 0,
    target: '',
    fixedLayers: []
  };

  const style = document.createElement('style');
  style.textContent = `
    #yoseen-scroll-probe {
      position: fixed;
      left: 8px;
      right: 8px;
      bottom: calc(8px + env(safe-area-inset-bottom, 0px));
      z-index: 2147483647;
      box-sizing: border-box;
      padding: 8px 10px;
      border-radius: 6px;
      background: rgba(18, 16, 15, 0.88);
      color: #fff;
      font: 11px/1.35 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      pointer-events: none;
      white-space: pre-wrap;
    }
  `;

  const panel = document.createElement('div');
  panel.id = 'yoseen-scroll-probe';
  panel.textContent = 'YOSEEN scroll probe starting...';

  const getNodeLabel = (node) => {
    if (!node) return 'none';
    const id = node.id ? `#${node.id}` : '';
    const className = typeof node.className === 'string'
      ? `.${node.className.trim().replace(/\s+/g, '.')}`
      : '';
    return `${node.tagName || 'node'}${id}${className}`.slice(0, 110);
  };

  const readFixedLayers = () => Array.from(document.querySelectorAll('body *'))
    .filter((node) => {
      if (node === panel) return false;
      const cs = getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.pointerEvents === 'none') return false;
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return false;
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    })
    .slice(0, 8)
    .map((node) => {
      const cs = getComputedStyle(node);
      const rect = node.getBoundingClientRect();
      return `${cs.position} ${Math.round(rect.top)},${Math.round(rect.height)} ${getNodeLabel(node)}`;
    });

  const ratioForGesture = () => {
    const fingerDelta = state.currentY - state.startY;
    const scrollDelta = window.scrollY - state.startScrollY;
    if (Math.abs(fingerDelta) < 1) return 0;
    const expected = fingerDelta < 0 ? -fingerDelta : fingerDelta;
    const actual = fingerDelta < 0 ? scrollDelta : -scrollDelta;
    return actual / expected;
  };

  let framePending = false;
  const render = () => {
    framePending = false;
    const fingerDelta = Math.round(state.currentY - state.startY);
    const scrollDelta = Math.round(window.scrollY - state.startScrollY);
    const ratio = ratioForGesture();
    const direction = fingerDelta < 0 ? 'finger up' : fingerDelta > 0 ? 'finger down' : 'idle';
    panel.textContent = [
      `scroll_probe=1 | ${direction}`,
      `fingerDelta: ${fingerDelta}px | scrollDelta: ${scrollDelta}px | ratio: ${ratio.toFixed(2)}`,
      `scrollY: ${Math.round(window.scrollY)} | max touch gap: ${Math.round(state.maxTouchGap)}ms | max scroll gap: ${Math.round(state.maxScrollGap)}ms`,
      `longTasks: ${state.longTasks} | max long task: ${Math.round(state.maxLongTask)}ms`,
      `touch target: ${state.target}`,
      `fixed/sticky layers:\n${state.fixedLayers.join('\n') || 'none'}`
    ].join('\n');
  };

  const scheduleRender = () => {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(render);
  };

  window.addEventListener('touchstart', (event) => {
    const touch = event.touches && event.touches[0];
    if (!touch) return;
    state.active = true;
    state.startY = touch.clientY;
    state.currentY = touch.clientY;
    state.startScrollY = window.scrollY;
    state.lastTouchTime = event.timeStamp;
    state.maxTouchGap = 0;
    state.maxScrollGap = 0;
    state.lastScrollTime = 0;
    state.target = getNodeLabel(document.elementFromPoint(touch.clientX, touch.clientY));
    state.fixedLayers = readFixedLayers();
    scheduleRender();
  }, { passive: true, capture: true });

  window.addEventListener('touchmove', (event) => {
    const touch = event.touches && event.touches[0];
    if (!touch) return;
    const gap = event.timeStamp - state.lastTouchTime;
    if (state.lastTouchTime) state.maxTouchGap = Math.max(state.maxTouchGap, gap);
    state.lastTouchTime = event.timeStamp;
    state.currentY = touch.clientY;
    state.target = getNodeLabel(document.elementFromPoint(touch.clientX, touch.clientY));
    scheduleRender();
  }, { passive: true, capture: true });

  window.addEventListener('touchend', () => {
    state.active = false;
    scheduleRender();
  }, { passive: true, capture: true });

  window.addEventListener('scroll', (event) => {
    const gap = event.timeStamp - state.lastScrollTime;
    if (state.lastScrollTime) state.maxScrollGap = Math.max(state.maxScrollGap, gap);
    state.lastScrollTime = event.timeStamp;
    scheduleRender();
  }, { passive: true });

  if ('PerformanceObserver' in window) {
    try {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          state.longTasks += 1;
          state.maxLongTask = Math.max(state.maxLongTask, entry.duration || 0);
        });
        scheduleRender();
      });
      observer.observe({ entryTypes: ['longtask'] });
    } catch (error) {
      // Long task observation is optional.
    }
  }

  const mount = () => {
    document.head.append(style);
    document.body.append(panel);
    state.fixedLayers = readFixedLayers();
    scheduleRender();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
